import React, { useState, useEffect } from "react";
import { AppSingleton, _healthInfoList } from "../services/user_config";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material";
import { getYoutubeInfoApi } from "../services/backend";

const HealthSectionListing = () => {
  const [vodInfos, setVodInfos] = useState([]);
  var appSingleton = new AppSingleton();

  useEffect(() => {
    Promise.allSettled(
      _healthInfoList.map((el) => getYoutubeInfoApi({ url: el.url }))
    )
      .then((responses) => {
        const mappedResponse = responses
          .map((response, index) => ({
            ..._healthInfoList[index],
            ...response,
          }))
          .filter((result) => result.status === "fulfilled");
        setVodInfos(mappedResponse);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, []);

  return (
    <>
      {vodInfos.map((el, index) => (
        <Card key={index} sx={{ m: 2 }}>
          <CardActionArea
            onClick={() => {
              appSingleton.navigate("/operation/media-section", {
                state: el,
              });
            }}
          >
            <CardContent
              sx={{
                display: "flex",
                justifyItems: "center",
              }}
            >
              <Box>
                <CardMedia
                  sx={{
                    height: (appSingleton.windowSize.width / 4 / 16) * 9,
                    width: appSingleton.windowSize.width / 4, //(192 * 16) / 9,
                    objectFit: "contain",
                  }}
                  image={el.value.thumbnail_url}
                  title="green iguana"
                />
              </Box>
              <Box sx={{ textAlign: "left", ml: 4, mr: 2 }}>
                <Typography variant="h6">{el.value.title}</Typography>
                <Typography variant="p">{el.value.author_name}</Typography>
                <Typography
                  sx={{
                    position: "absolute",
                    bottom: 32,
                    right: 32,
                  }}
                >
                  {el.value.provider_name}
                </Typography>
              </Box>
            </CardContent>
          </CardActionArea>
        </Card>
      ))}
    </>
  );
};

export { HealthSectionListing };
